import type {
  GenerateOtpRequest,
  GenerateOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  AssociateOtpRequest,
  AssociateOtpResponse,
  VerifyEmailRequest,
  VerifyEmailResponse,
  RegisterRequest,
  RegisterResponse,
  RegisterWithPasswordRequest,
  RegisterWithPasswordResponse,
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  CheckEmailRequest,
  CheckEmailResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
} from './utils/types';
import { cartClient } from '../common/cartClient';

class AuthAPIClient {
  public async generateOtp(payload: GenerateOtpRequest): Promise<GenerateOtpResponse> {
    const response = await cartClient.post('/otp/generate', payload).then((res) => res.data);
    return response;
  }

  public async verifyOtp(payload: VerifyOtpRequest): Promise<VerifyOtpResponse> {
    const response = await cartClient.post('/otp/verify', payload).then((res) => res.data);
    return response;
  }

  public async associateOtp(payload: AssociateOtpRequest): Promise<AssociateOtpResponse> {
    const response = await cartClient.post('/otp/associate', payload).then((res) => res.data);
    return response;
  }

  public async verifyEmail(payload: VerifyEmailRequest): Promise<VerifyEmailResponse> {
    const response = await cartClient.post('/otp/verifyEmail', payload).then((res) => res.data);
    return response;
  }

  public async register(payload: RegisterRequest): Promise<RegisterResponse> {
    const response = await cartClient.post('/auth/register', payload).then((res) => res.data);
    return response;
  }

  public async registerWithPassword(payload: RegisterWithPasswordRequest): Promise<RegisterWithPasswordResponse> {
    const response = await cartClient.post('/auth/registerWithPassword', payload).then((res) => res.data);
    return response;
  }

  public async login(payload: LoginRequest): Promise<LoginResponse> {
    const response = await cartClient.post('/auth/login', payload).then((res) => res.data);
    return response;
  }

  public async logout(): Promise<LogoutResponse> {
    const response = await cartClient.post('/auth/logout').then((res) => res.data);
    return response;
  }

  public async checkEmail(payload: CheckEmailRequest): Promise<CheckEmailResponse> {
    const { email } = payload;
    const response = await cartClient.post('/auth/checkEmail', { email }).then((res) => res.data);
    return response;
  }

  public async changePassword(payload: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    const response = await cartClient.post('/auth/changePassword', payload).then((res) => res.data);
    return response;
  }
}

export const authAPIClient = new AuthAPIClient();
